import { IOptions } from "./types";

export const DEFAULT_OPTIONS: Partial<IOptions> = {
  theme: "light",
};
